"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tom_select_ts_1 = require("./tom-select.js");
const plugin_ts_1 = require("./plugins/change_listener/plugin.js");
const plugin_ts_2 = require("./plugins/checkbox_options/plugin.js");
const plugin_ts_3 = require("./plugins/clear_button/plugin.js");
const plugin_ts_4 = require("./plugins/drag_drop/plugin.js");
const plugin_ts_5 = require("./plugins/dropdown_header/plugin.js");
const plugin_ts_6 = require("./plugins/caret_position/plugin.js");
const plugin_ts_7 = require("./plugins/dropdown_input/plugin.js");
const plugin_ts_8 = require("./plugins/input_autogrow/plugin.js");
const plugin_ts_9 = require("./plugins/no_backspace_delete/plugin.js");
const plugin_ts_10 = require("./plugins/no_active_items/plugin.js");
const plugin_ts_11 = require("./plugins/optgroup_columns/plugin.js");
const plugin_ts_12 = require("./plugins/remove_button/plugin.js");
const plugin_ts_13 = require("./plugins/restore_on_backspace/plugin.js");
const plugin_ts_14 = require("./plugins/virtual_scroll/plugin.js");
tom_select_ts_1.default.define('change_listener', plugin_ts_1.default);
tom_select_ts_1.default.define('checkbox_options', plugin_ts_2.default);
tom_select_ts_1.default.define('clear_button', plugin_ts_3.default);
tom_select_ts_1.default.define('drag_drop', plugin_ts_4.default);
tom_select_ts_1.default.define('dropdown_header', plugin_ts_5.default);
tom_select_ts_1.default.define('caret_position', plugin_ts_6.default);
tom_select_ts_1.default.define('dropdown_input', plugin_ts_7.default);
tom_select_ts_1.default.define('input_autogrow', plugin_ts_8.default);
tom_select_ts_1.default.define('no_backspace_delete', plugin_ts_9.default);
tom_select_ts_1.default.define('no_active_items', plugin_ts_10.default);
tom_select_ts_1.default.define('optgroup_columns', plugin_ts_11.default);
tom_select_ts_1.default.define('remove_button', plugin_ts_12.default);
tom_select_ts_1.default.define('restore_on_backspace', plugin_ts_13.default);
tom_select_ts_1.default.define('virtual_scroll', plugin_ts_14.default);
exports.default = tom_select_ts_1.default;
//# sourceMappingURL=tom-select.complete.js.map